// extracted by mini-css-extract-plugin
export default {"imageContainer":"AppLicense_imageContainer__cVuLH","modalContainer":"AppLicense_modalContainer__2Pe7A"};